import React from 'react';
import styled from 'styled-components';
import RaisedButton from 'material-ui/RaisedButton';
import noEntry from '../../images/no-entry.png';
import { auth } from '../../utils/configureFirebase';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;

  img {
    width: 400px;
    margin-bottom: 16px;
  }

  h1 {
    margin: 0 0 16px 0;
    color: ${props => props.theme.accent1Color};
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }
`;

const NoAccess = () => (
  <Wrapper>
    <img src={noEntry} alt="No Entry" />
    <h1>Access Denied</h1>
    <RaisedButton
      secondary
      label="Logout"
      onTouchTap={() => {
        auth.signOut();
      }}
    />
  </Wrapper>
);

export default NoAccess;



// WEBPACK FOOTER //
// ./src/views/NoAccess/NoAccess.js